<header class="topbar">
  <div class="tb-brand"><div class="mark">T</div></div>
  <div class="ptitle">{{ pageTitleSvc.title() }}</div>
  <div class="topbar-right">
    <button *ngIf="mv.canSwitch()" class="topswitch" type="button" title="Switch vendor" aria-label="Switch vendor" (click)="switchVendor.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3l4 4-4 4"/><path d="M20 7H4"/><path d="M8 21l-4-4 4-4"/><path d="M4 17h16"/></svg>
    </button>
    <button class="profbtn-av" type="button" title="Profile & settings" (click)="goProfile()">
      <span class="prof-av">
        <img *ngIf="mv.logo(); else initialsTpl" [src]="mv.logo()" alt="">
        <ng-template #initialsTpl>{{ avatarInitials() }}</ng-template>
      </span>
    </button>
  </div>
</header>
